/**
 * Defines the constants used by the Docs module.
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 * @author DJ Kim <DJ@thebrandingfarm.com>
 */
export const VUEX_DOCS_GET_REQUEST                  = 'VUEX_DOCS_GET_REQUEST'
export const VUEX_DOCS_GET_SUCCESS                  = 'VUEX_DOCS_GET_SUCCESS'
export const VUEX_DOCS_GET_FAILURE                  = 'VUEX_DOCS_GET_FAILURE'
export const VUEX_DOCS_SET_APPROVED                 = 'VUEX_DOCS_SET_APPROVED'
export const VUEX_DOCS_APPLY_FILTERS                = 'VUEX_DOCS_APPLY_FILTERS'
export const VUEX_DOCS_CLEAR_FILTERS                = 'VUEX_DOCS_CLEAR_FILTERS'
export const VUEX_DOCS_APPLY_STATUS_FILTER          = 'VUEX_DOCS_APPLY_STATUS_FILTER'
export const VUEX_DOCS_APPLY_PROGRESS_FILTER        = 'VUEX_DOCS_APPLY_PROGRESS_FILTER'
export const VUEX_DOCS_APPLY_TYPE_FILTER            = 'VUEX_DOCS_APPLY_TYPE_FILTER'
export const VUEX_DOCS_APPLY_DEPARTMENT_FILTER      = 'VUEX_DOCS_APPLY_DEPARTMENT_FILTER'
export const VUEX_DOCS_APPLY_CREATIVE_ROUND_FILTER  = 'VUEX_DOCS_APPLY_CREATIVE_ROUND_FILTER'
export const VUEX_DOCS_SYNC_PAGINATION              = 'VUEX_DOCS_SYNC_PAGINATION'

export const VUEX_DOC_GET_REQUEST                   = 'VUEX_DOC_GET_REQUEST'
export const VUEX_DOC_GET_SUCCESS                   = 'VUEX_DOC_GET_SUCCESS'
export const VUEX_DOC_GET_EVENTS_SUCCESS            = 'VUEX_DOC_GET_EVENTS_SUCCESS'
export const VUEX_DOC_GET_FILES_SUCCESS             = 'VUEX_DOC_GET_FILES_SUCCESS'
export const VUEX_DOC_GET_FAILURE                   = 'VUEX_DOC_GET_FAILURE'
export const VUEX_DOC_UPDATE_INIT                   = 'VUEX_DOC_UPDATE_INIT'
export const VUEX_DOC_UPDATE_APPLY_TEMPLATE         = 'VUEX_DOC_UPDATE_APPLY_TEMPLATE'
export const VUEX_DOC_UPDATE_PROP                   = 'VUEX_DOC_UPDATE_PROP'
export const VUEX_DOC_UPDATE_REQUEST                = 'VUEX_DOC_UPDATE_REQUEST'
export const VUEX_DOC_UPDATE_REQUEST_SUCCESS        = 'VUEX_DOC_UPDATE_REQUEST_SUCCESS' 
export const VUEX_DOC_UPDATE_REQUEST_FAILURE        = 'VUEX_DOC_UPDATE_REQUEST_FAILURE'
export const VUEX_DOC_SAVE_DOC_NAME                 = 'VUEX_DOC_SAVE_DOC_NAME'
export const VUEX_DOC_TEAM_ADD_MEMBER               = 'VUEX_DOC_TEAM_ADD_MEMBER'
export const VUEX_DOC_TEAM_ADD_MEMBER_SUCCESS       = 'VUEX_DOC_TEAM_ADD_MEMBER_SUCCESS'
export const VUEX_DOC_TEAM_ADD_MEMBER_FAILURE       = 'VUEX_DOC_TEAM_ADD_MEMBER_FAILURE'
export const VUEX_DOC_TEAM_REMOVE_MEMBER            = 'VUEX_DOC_TEAM_REMOVE_MEMBER'
export const VUEX_DOC_TEAM_REMOVE_MEMBER_SUCCESS    = 'VUEX_DOC_TEAM_REMOVE_MEMBER_SUCCESS'
export const VUEX_DOC_TEAM_REMOVE_MEMBER_FAILURE    = 'VUEX_DOC_TEAM_REMOVE_MEMBER_FAILURE'

export const VUEX_DOC_CREATE_INIT                   = 'VUEX_DOC_CREATE_INIT'
export const VUEX_DOC_CREATE                        = 'VUEX_DOC_CREATE'
export const VUEX_DOC_CREATE_SUCCESS                = 'VUEX_DOC_CREATE_SUCCESS'
export const VUEX_DOC_CREATE_FAILURE                = 'VUEX_DOC_CREATE_FAILURE'
export const VUEX_DOC_CREATE_UPDATE                 = 'VUEX_DOC_CREATE_UPDATE'
export const VUEX_DOC_CREATE_UPDATE_SUCCESS         = 'VUEX_DOC_CREATE_UPDATE_SUCCESS'
export const VUEX_DOC_CREATE_UPDATE_FAILURE         = 'VUEX_DOC_CREATE_UPDATE_FAILURE'
export const VUEX_DOC_CREATE_APPLY_TEMPLATE         = 'VUEX_DOC_CREATE_APPLY_TEMPLATE' 
export const VUEX_DOC_CREATE_UPDATE_PROP            = 'VUEX_DOC_CREATE_UPDATE_PROP'
export const VUEX_DOC_CREATE_CANCEL                 = 'VUEX_DOC_CREATE_CANCEL'
export const VUEX_DOC_CREATE_CANCEL_PROMPT          = 'VUEX_DOC_CREATE_CANCEL_PROMPT'
export const VUEX_DOC_CREATE_HAS_CHANGED            = 'VUEX_DOC_CREATE_HAS_CHANGED'
export const VUEX_DOC_CREATE_CLEAR_PROPS_TO_UPDATE  = 'VUEX_DOC_CREATE_CLEAR_PROPS_TO_UPDATE'

export const VUEX_DOC_REMOVE                        = 'VUEX_DOC_REMOVE'
export const VUEX_DOC_REMOVE_SUCCESS                = 'VUEX_DOC_REMOVE_SUCCESS'
export const VUEX_DOC_REMOVE_FAILURE                = 'VUEX_DOC_REMOVE_FAILURE'

export const VUEX_DOC_ATTACH_FILE                   = 'VUEX_DOC_ATTACH_FILE'
export const VUEX_DOC_GET_ATTACHMENTS               = 'VUEX_DOC_GET_ATTACHMENTS'
export const VUEX_DOC_GET_ATTACHMENTS_SUCCESS       = 'VUEX_DOC_GET_ATTACHMENTS_SUCCESS'
export const VUEX_DOC_REMOVE_FILE                   = 'VUEX_DOC_REMOVE_FILE'
export const VUEX_DOC_REMOVE_FILE_SUCCESS           = 'VUEX_DOC_REMOVE_FILE_SUCCESS'
export const VUEX_DOC_DOWNLOAD_ATTACHMENT           = 'VUEX_DOC_DOWNLOAD_ATTACHMENT'
